import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { AllocateClaimsFullView } from '../components/views/allocateClaimsFullView'

function AllocateClaimsFull() {
    return (
        <div className="allocateClaimsFull">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Allocate Claims (Full)'} />
                <AllocateClaimsFullView />
            </MainView>
        </div>
    )
}

export default AllocateClaimsFull
